/* ==========================================================================
   DEMIGODS — Countdown

   The launch moment is stored as an absolute UTC instant, so Date.parse gives
   the same epoch millisecond in every timezone. Minimog's own countdown parses
   a bare "2026-09-29 12:00:00", which resolves in the visitor's local time and
   drifts by hours either way.
   ========================================================================== */

(function () {
  'use strict';

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function initCountdown(root) {
    var launchAt = Date.parse(root.getAttribute('data-launch'));
    if (isNaN(launchAt)) {
      console.warn('[demigods] Countdown launch date could not be parsed. Expected an ISO-8601 UTC value such as 2026-09-29T12:00:00Z.');
      return;
    }

    var fields = {
      days: root.querySelector('[data-dg-days]'),
      hours: root.querySelector('[data-dg-hours]'),
      minutes: root.querySelector('[data-dg-minutes]'),
      seconds: root.querySelector('[data-dg-seconds]')
    };

    var timer = null;

    function write(d, h, m, s) {
      if (fields.days) fields.days.textContent = pad(d);
      if (fields.hours) fields.hours.textContent = pad(h);
      if (fields.minutes) fields.minutes.textContent = pad(m);
      if (fields.seconds) fields.seconds.textContent = pad(s);
    }

    function tick() {
      var remaining = Math.floor((launchAt - Date.now()) / 1000);

      if (remaining <= 0) {
        write(0, 0, 0, 0);
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
        return;
      }

      write(
        Math.floor(remaining / 86400),
        Math.floor(remaining / 3600) % 24,
        Math.floor(remaining / 60) % 60,
        remaining % 60
      );
    }

    tick();
    if (Date.now() < launchAt) {
      timer = setInterval(tick, 1000);
    }
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-dg-countdown]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.getAttribute('data-dg-countdown-ready') === 'true') return;
      root.setAttribute('data-dg-countdown-ready', 'true');
      initCountdown(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Theme editor re-renders sections in isolation. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
